<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-3 pt-5 pt-md-8">
            
    </base-header>
        <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">Nhật Ký</h3>
                  </div>
                </div>
              </div>
              <template>
                <form>
                  <h6 class="heading-small text-muted mb-4">Tổ Chức</h6>
                  <div>
                    <v-select label="name" :options="organizations" v-model="selectedOrg" :components="{OpenIndicator}" @input="getTenants"></v-select>
                  </div>
                  <div>
                     <base-input label="Vai Trò" v-if=" selectedOrg && selectedOrg.type==3">
                        <select class="form-control" v-model.number="orgType">
                          <option value=1>Khách Hàng</option>
                          <option value=2>Đối Tác</option>
                        </select>
                        </base-input>
                  </div>
                  <!-- Address -->
                  <h6 class="heading-small text-muted mb-4">Danh sách Nhân Sự</h6>
                  <div class="table-responsive">
                      <base-table thead-classes="thead-light"
                        :data="listTenants">
                        <template slot="columns">
                          <th>
                           
                            <label class="form-checkbox">
                            <input type="checkbox" v-model="selectAll" @click="select"> 
                            <i class="form-icon"></i>
                            </label>
                            
                          </th>
                          <th>Họ Tên</th>
                          <th>Số Căn Cước</th>
                          <th>Passport ID</th>
                          <th>Mobile</th>
                          <th>Trạng Thái</th>
                          <th>Từ Ngày</th>
                          <th>Đến Ngày</th>
                          <th></th>
                        </template>
                        <template slot-scope="{row}">
                          <td>
                            
                            <label class="form-checkbox">
                            <input type="checkbox" :value="row" v-model="selectTenants"> 
                            <i class="form-icon"></i>
                            </label>
                        
                          </td>
                          <td scope="row">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <span class="name mb-0 text-sm">{{row.name}}</span>
                              </div>
                            </div>
                          </td>
                          <td class="budget">
                            {{row.nationalid}}
                          </td>
                          <td class="budget">
                            {{row.passportid}}
                          </td>
                          <td>
                            {{row.mobile}}
                          </td>
                          <td>
                            <badge pill v-if="row.status" type="info">Active</badge>
                            <badge pill v-else type="danger">Disable</badge>
                          </td>
                          <td>
                            {{row.beginDate | moment("DD/MM/YYYY")}}
                          </td>
                          <td>
                            {{row.endDate | moment("DD/MM/YYYY")}}
                          </td>
                          <td>
                          </td>
                        </template>

                      </base-table>
                  </div>
                  <div v-if="invalidTenants.length">
                    <hr class="my-4">
                    <h6 class="heading-small text-muted mb-4">Danh sách không hợp lệ</h6>
                    <div class="table-responsive">
                      <base-table thead-classes="thead-light"
                        :data="invalidTenants">
                        <template slot="columns">
                          <th>Họ Tên</th>
                          <th>Số Căn Cước</th>
                          <th>Passport ID</th>
                          <th>Mobile</th>
                          <th>Trạng Thái</th>
                          <th>Từ Ngày</th>
                          <th>Đến Ngày</th>
                          <th></th>
                        </template>
                        <template slot-scope="{row}">
                          <td scope="row">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <span class="name mb-0 text-sm">{{row.name}}</span>
                              </div>
                            </div>
                          </td>
                          <td class="budget">
                            {{row.nationalid}}
                          </td>
                          <td class="budget">
                            {{row.passportid}}
                          </td>
                          <td>
                            {{row.mobile}}
                          </td>
                          <td>
                            <badge pill v-if="row.status" type="info">Active</badge>
                            <badge pill v-else type="danger">Disable</badge>
                          </td>
                          <td>
                            {{row.beginDate | moment("DD/MM/YYYY")}}
                          </td>
                          <td>
                            {{row.endDate | moment("DD/MM/YYYY")}}
                          </td>
                          <td>
                          </td>
                        </template>

                      </base-table>
                    </div>
                  </div
                  <hr class="my-4">
                  <!-- Description -->
                  <div class="row">
                    <div class="col">
                      <h6 class="heading-small text-muted mb-4">Mục Đích</h6>
                      <base-input class="mb-4">
                        <textarea class="form-control" id="FormControlTextarea1" rows="3" placeholder="mục đích công việc ..." v-model="content"></textarea>
                      </base-input>
                    </div>
                    <div class="col">
                      <h6 class="heading-small text-muted mb-4">Ghi Chú</h6>
                      <base-input class="mb-4">
                        <textarea class="form-control" id="FormControlTextarea2" rows="3" placeholder="ghi chú thêm ..." v-model="notes"></textarea>
                      </base-input>
                    </div>
                    
                  </div>
                  <div class="col text-right">
                      
                      <base-button type="primary btn-sm" class="my-4" @click="createevent" >Thêm</base-button>
                    </div>
                </form>
              </template>
        </card>
      </div>
</template>
<script>
export default {
  props: {

  },
  data() {
    return {
        organizations: [],
        err: '',
        selectedOrg: {default: null},
        OpenIndicator: {
        render: createElement => createElement('span', {class: {'toggle': true}}),
        },
        listTenants: [],
        selectTenants: [],
        selectAll: false,
        content: '',
        notes: '',
        shiftId: '',
        location: '',
        orgType: 1,
        invalidTenants: [],
       }
  },
  mounted() {
    this.listOrgs(),
    this.getTenants()
    this.getlocation()
    this.getCurShift()
  },
  methods: {
    getlocation() {
      this.location = this.$route.query.location
    },
    listOrgs() {
      this.$http.get('/organizations').then((res) => {
        this.organizations = res.data
      })
    },
    async getCurShift() {
      let res = ''
      if (this.location == 'TTN') {
        res = await this.$http.get('/ttn/cur')
      } else if (this.location == 'DBP') {
        res = await this.$http.get('/dbp/cur')
      }
      else {
        res = await this.$http.get('/ntmk/cur')
      }
      this.shiftId = res.data._id
    },
    async getTenants(org){
        let tenants = []
        let rawtenants = []
        let curjobs = []
        this.listTenants = []
        this.invalidTenants = []
        if(org) {
           let res = await this.$http.get('/tenants/org', {params:{"orgid": org._id}})
           rawtenants = res.data
           this.orgType = org.type
          }
        else {
          let res = await this.$http.get('/tenants')
          rawtenants  = res.data 
        }
        let res = await this.$http.get('/jobs', {params:{"openning": true}})
        curjobs = res.data
        if(curjobs.length && rawtenants.length){
          for(let i=0; i<rawtenants.length; i++){
            for(let j=0; j < curjobs.length; j++) {
              if(rawtenants[i]._id == curjobs[j].tenantId)
              {
                break;
              }
              if(j == curjobs.length -1){
                tenants.push(rawtenants[i])
              }
            }
          }
        }
        else {
          tenants = rawtenants
        }
        for(let i=0;i<tenants.length;i += 1){
          if(tenants[i].status && new Date(tenants[i].beginDate) < new Date() && (new Date(tenants[i].endDate) > new Date((new Date()).valueOf() - 1000*3600*24) || tenants[i].endDate === null)){
            this.listTenants.push(tenants[i])
          }
          else if(tenants[i].status && typeof tenants[i].beginDate ==='undefined' && typeof tenants[i].endDate ==='undefined') {
            this.listTenants.push(tenants[i])
          }
          else if(tenants[i].status && tenants[i].beginDate ===null && tenants[i].endDate ===null) {
            this.listTenants.push(tenants[i])
          }
          else{
            this.invalidTenants.push(tenants[i])
          }
        }
    },
    select() {
			this.selectTenants = []
			if (!this.selectAll) {
				this.listTenants.forEach((tenant) => {
          this.selectTenants.push(tenant)
        })
			}
    },
    createevent() {
        this.selectTenants.forEach( async (element)=> {
        let identity =''
        if(element.nationalid){
          identity = element.nationalid
        }
        else{
          identity = element.passportid
        }
        let data = {
          tenant: element.name,
          tenantId: element._id,
          tenantNational: identity,
          orgName: this.selectedOrg.name,
          orgId:  this.selectedOrg._id,
          shiftId: this.shiftId,
          content: this.content,
          notes: this.notes,
          location: this.location,
          orgType: this.orgType
        }
        await this.$http.post('/jobs/add', data)
        
    })
    this.$router.push('/events')
  }
}
}
</script>
<style>
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }
</style>